import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "",

        async overviewAdmin({ date, devices, advertising, users } = {}) {
            const url = this.userUrl({ path: "/visao-geral-admin" });

            const query = buildQueryParams({
                date,
                devices,
                advertising,
                users
            });

            return Vue.http.get(url, {
                params: query
            });
        },

        async overview() {
            const url = this.userUrl({ path: `/visao-geral` });

            return await Vue.http.get(url);
        }
    },
    base
);

const buildQueryParams = ({ date, devices, advertising, users } = {}) => {
    return {
        "data.min": date && date.min,
        "data.max": date && date.max,
        aparelhos: devices,
        campanhas: advertising,
        usuarios: users
    };
};
